import { getEnvironmentConfig, getEnvVariable } from '../configHelper.js';
import { Brands } from '@framework/brands';
export var AspectRatio;
(function (AspectRatio) {
    AspectRatio[AspectRatio["SQUARE"] = 1] = "SQUARE";
    AspectRatio[AspectRatio["WIDESCREEN"] = 1.7778] = "WIDESCREEN";
    AspectRatio[AspectRatio["ULTRAWIDESCREEN"] = 2.3333] = "ULTRAWIDESCREEN";
})(AspectRatio || (AspectRatio = {}));
const definition = {
    base: {
        cdn: {
            cdnUrl: 'https://local-thumbor.burda-forward.de',
            hashSecret: 'FmRmm#DEFTeUoQ6RbBxKBgXn',
            isHashModeOn: true,
        },
        s3: {
            region: 'eu-central-1',
            bucketName: 's3local',
            forcePathStyle: true,
        },
        upload: {
            getFileUrl: (fileName) => `https://local-s3.burda-forward.de/s3local/${fileName}`,
        },
        OgImage: {
            width: 1200,
            height: 630,
        },
        legacy: {
            defaultImageId: {
                [Brands.FOCUS]: 'fc5d3e8b-6f5e-43b4-b6e5-c5b5e4d58b2d',
                [Brands.BUNTE]: 'fc5d3e8b-6f5e-43b4-b6e5-c5b5e4d58b2d',
                [Brands.CHIP]: '6ad633c4-033a-4ef0-8e66-8ad227839d75',
            },
        },
    },
    local: {
        s3: {
            credentials: {
                // Local MinIO Credentials
                accessKeyId: 'AKIAIOSFODNN7EXAMPLE',
                secretAccessKey: 'wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY',
            },
            endpoint: 'https://local-s3.burda-forward.de:443',
        },
    },
    local_k8s: {
        s3: {
            credentials: {
                // Local MinIO Credentials
                accessKeyId: 'AKIAIOSFODNN7EXAMPLE',
                secretAccessKey: 'wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY',
            },
            // In-cluster MinIO; public URLs stay on local-s3.burda-forward.de via Traefik.
            endpoint: 'http://s3-local:9002',
        },
    },
    local_e2e: {
        s3: {
            credentials: {
                // Local MinIO Credentials
                accessKeyId: 'AKIAIOSFODNN7EXAMPLE',
                secretAccessKey: 'wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY',
            },
            endpoint: 'https://local-s3.burda-forward.de:443',
        },
    },
    development: {
        cdn: {
            cdnUrl: 'https://quadro-development.burda-forward.de/ctf',
            hashSecret: getEnvVariable('AKAMAI_HASH_SHARED_SECRET'),
        },
        s3: {
            bucketName: 'ctf-vibe-images-development-eu-central-1',
            forcePathStyle: false,
        },
        upload: {
            getFileUrl: (fileName) => `https://ctf-vibe-images-development-eu-central-1.s3.eu-central-1.amazonaws.com/${fileName}`,
        },
        legacy: {
            defaultImageId: {
                [Brands.FOCUS]: '3232e577-e843-477d-b913-15428acd66a1',
                [Brands.BUNTE]: '8d2ac2ca-9045-4150-88c2-30f5969693c0',
                [Brands.CHIP]: 'f36516b8-5805-41b7-8c60-32f59083f4fe',
            },
        },
    },
    sandbox: {
        cdn: {
            cdnUrl: 'https://quadro-sandbox.burda-forward.de/ctf',
            hashSecret: getEnvVariable('AKAMAI_HASH_SHARED_SECRET'),
        },
        s3: {
            bucketName: 'ctf-vibe-images-sandbox-eu-central-1',
            forcePathStyle: false,
        },
        upload: {
            getFileUrl: (fileName) => `https://ctf-vibe-images-sandbox-eu-central-1.s3.eu-central-1.amazonaws.com/${fileName}`,
        },
    },
    test: {
        cdn: {
            cdnUrl: 'https://test-thumbor.burda-forward.de',
            hashSecret: 'somesecretcode',
        },
        s3: {
            bucketName: 'ctf-vibe-images-test-eu-central-1',
            forcePathStyle: false,
        },
        upload: {
            getFileUrl: (fileName) => `https://ctf-vibe-images-test-eu-central-1.s3.eu-central-1.amazonaws.com/${fileName}`,
        },
    },
    staging: {
        cdn: {
            cdnUrl: 'https://quadro-staging.burda-forward.de/ctf',
            hashSecret: getEnvVariable('AKAMAI_HASH_SHARED_SECRET'),
        },
        s3: {
            bucketName: 'ctf-vibe-images-staging-eu-central-1',
            forcePathStyle: false,
        },
        upload: {
            getFileUrl: (fileName) => `https://ctf-vibe-images-staging-eu-central-1.s3.eu-central-1.amazonaws.com/${fileName}`,
        },
        legacy: {
            defaultImageId: {
                [Brands.FOCUS]: '78ce9fc2-7819-4929-b21a-2c3746f138ad',
                [Brands.BUNTE]: '78ce9fc2-7819-4929-b21a-2c3746f138ad',
                [Brands.CHIP]: 'ce225572-697d-4108-bb46-5c2a47279fa5',
            },
        },
    },
    production: {
        cdn: {
            cdnUrl: 'https://quadro.burda-forward.de/ctf',
            hashSecret: getEnvVariable('AKAMAI_HASH_SHARED_SECRET'),
        },
        s3: {
            bucketName: 'ctf-vibe-images-production-eu-central-1',
            forcePathStyle: false,
        },
        upload: {
            getFileUrl: (fileName) => `https://ctf-vibe-images-production-eu-central-1.s3.eu-central-1.amazonaws.com/${fileName}`,
        },
        legacy: {
            defaultImageId: {
                [Brands.FOCUS]: '3de37fde-807d-41fb-9296-9a22bc9ede43',
                [Brands.BUNTE]: '4c1b4694-4e82-48e6-af97-21ae4e68936a',
                [Brands.CHIP]: 'db4b1390-e93f-4291-a42c-cfa847f82df2',
            },
        },
    },
};
export const imageConfig = () => getEnvironmentConfig(definition);
//# sourceMappingURL=image.config.js.map